export interface Institution {
    institution_id?: number;
    bezeichnung?: string;
    bezeichnung_kurz?: string;
    strasse?: string;
    plz?: string;
    ort?: string;
    institution_art?: string;
    fibu_debitor_konto_id?: number;
    fibu_kreditor_konto_id?: number;
    default_erloes_konto_id?: number;
    debitor_konto_nr?: string;
    debitor_konto?: string;
    kreditor_konto_nr?: string;
    kreditor_konto?: string;
    erloes_konto_nr?: string;
    erloes_konto?: string;
    aktiv?: number;
    kommentar?: string;
    anzeige?: string;
}

export const INSTITUTION_ARTEN = [
    { id: 'TSK', label: 'Tierseuchenkasse' },
    { id: 'KAMMER', label: 'Kammer' },
    { id: 'ZUSCHUSS', label: 'Zuschussgeber' },
    { id: 'SONSTIG', label: 'Sonstiges' },
];
